export const PASSKEY_PREFERENCE_KEY = 'passkeyPreference';

export const shouldSkipPasskey = (): boolean => {
    try {
        const item = localStorage.getItem(PASSKEY_PREFERENCE_KEY);
        if (!item) return false;
        return !!JSON.parse(item)?.skipPasskey;
    } catch {
        return false;
    }
};
